<template>
  <b-form class="mt-3" @submit="onSubmitForm">
    <b-row>
      <b-col cols="6" md="3">
        <InputFilter :filter="search[0]" />
      </b-col>
      <b-col cols="6" md="3">
        <InputFilter :filter="search[1]" />
      </b-col>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[2]" />
      </b-col>
      <b-col cols="6" md="3">
        <InputFilter :filter="search[3]" />
      </b-col>
      <b-col cols="6" md="3">
        <InputFilter :filter="search[4]" />
      </b-col>

      <b-col v-if="this.isProvincialOfficer() === false" cols="6" md="3">
        <InputFilter :filter="search[5]" @select-input="onAreaSelectInput" />
      </b-col>

      <b-col v-if="this.isProvincialOfficer() === false" cols="6" md="3">
        <InputFilter :filter="search[6]" />
      </b-col>
    </b-row>

    <!-- Action Buttons -->
    <div class="text-center pt-1">
      <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        type="submit"
      >
        ค้นหา
      </b-button>
      <b-button
        variant="outline-secondary"
        type="reset"
        @click="onResetBtnClicked"
      >
        ล้าง
      </b-button>
    </div>
  </b-form>
</template>

<script>
import {
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import InputFilter from "../../../filters/components/InputFilter.vue";
import * as userData from "@/auth/localStorageUtils.js";
import * as verifyStore from "@/store/api/verify/index.js";
import * as storeMaster from "@/store/api/master/index.js";

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    vSelect,
    InputFilter,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  mounted() {
    console.log("this.provinces", this.provinces);
    this.getArea();
    this.getProvinces(null);
    this.getVerifyDeps();
    this.getVerifyMinistries();
  },
  data() {
    const areas = [];
    const provinces = [];
    const verifyDeps = [];
    const verifyMinistries = [];

    const searchList = [
      {
        id: "verifyDepId",
        label: "ประเภทการตรวจสอบ",
        value: "",
        class: "",
        style: "",
        placeholder: "ประเภทการตรวจสอบ",
        type: "bselect",
        options: verifyDeps,
      },
      {
        id: "verifyMinistry",
        label: "ประกาศ/คำสั่ง/กฏกระทรวง/ระเบียบ",
        value: "",
        class: "",
        style: "",
        placeholder: "ประกาศ/คำสั่ง/กฏกระทรวง/ระเบียบ",
        type: "bselect",
        options: verifyMinistries,
      },
      {
        id: "compName",
        label: "ชื่อผู้ประกอบการ",
        value: "",
        class: "",
        style: "",
        placeholder: "ชื่อผู้ประกอบการ",
        type: "text",
        options: [],
      },
      {
        id: "startDate",
        label: "ช่วงเวลา",
        value: "",
        class: "",
        style: "",
        placeholder: "จากวันที่",
        type: "date",
        options: [],
      },
      {
        id: "endDate",
        label: "ถึง",
        value: "",
        class: "",
        style: "",
        placeholder: "ถึงวันที่",
        type: "date",
        options: [],
      },
      {
        id: "areaCode",
        label: "เขต",
        value: "",
        class: "",
        style: "",
        placeholder: "เขต",
        type: "bselect",
        options: areas,
      },
      {
        id: "provinceCode",
        label: "จังหวัด",
        value: "",
        class: "",
        style: "",
        placeholder: "จังหวัด",
        type: "bselect",
        options: provinces,
      },
    ];
    return {
      search: searchList,
      provinces,
      areas,
      verifyDeps,
      verifyMinistries,
    };
  },
  methods: {
    onSubmitForm(e) {
      e.preventDefault();
      this.onSearchBtnClicked();
    },
    isProvincialOfficer() {
      if ("25e8af7c-d072-47fd-985b-fb1eefc44764" === userData.selectedRole()) {
        return true;
      }

      return false;
    },
    onResetBtnClicked() {
      this.search[0].value = null;
      this.search[1].value = null;
      this.search[2].value = null;
      this.search[3].value = null;
      this.search[4].value = null;
      this.search[5].value = null;
      this.search[6].value = null;
    },
    onSearchBtnClicked() {
      const params = {
        verifyDepId: this.search[0].value,
        verifyMinistry: this.search[1].value,
        compName: this.search[2].value,
        startDate: this.search[3].value,
        endDate: this.search[4].value,
        areaCode: this.search[5].value,
        provinceCode: this.search[6].value,
      };

      console.log("onSearchBtnClicked", params);

      this.$emit("handleSubmit", params);
    },
    onAreaSelectInput(param) {
      console.log("onAreaSelectInput", param);
      this.getProvinces(param.value);
    },
    getArea() {
      const _this = this;

      storeMaster
        .getArea()
        .then(function(response) {
          _this.areas = response.data.data;
          _this.search[5].options = _this.areas;
          _this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    getProvinces(areaCode) {
      const _this = this;

      if (areaCode !== null && areaCode !== undefined) {
        storeMaster
          .getProvinceByArea(areaCode)
          .then(function(response) {
            _this.provinces = response.data.data;
            _this.search[6].options = _this.provinces;
            _this.$forceUpdate();
            console.log("this.provinces", _this.provinces);
          })
          .catch(function(error) {
            // handle error
            console.log("error", error);
          });
      } else {
        storeMaster
          .getProvince()
          .then(function(response) {
            _this.provinces = response.data.data;
            _this.search[6].options = _this.provinces;
            _this.$forceUpdate();
            console.log("this.provinces", _this.provinces);
          })
          .catch(function(error) {
            // handle error
            console.log("error", error);
          });
      }
    },
    getVerifyDeps() {
      const _this = this;

      verifyStore
        .getVerifyDeps()
        .then(function(response) {
          _this.verifyDeps = response.data.data.map((value) => {
            return {
              text: value.description,
              value: String(value.verifyDepId),
            };
          });
          console.log("_this.verifyDeps", _this.verifyDeps);
          _this.search[0].options = _this.verifyDeps;
          _this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    getVerifyMinistries() {
      const _this = this;

      verifyStore
        .getAllVerifyMinistries()
        .then(function(response) {
          _this.verifyMinistries = response.data.data.map((value) => {
            return {
              text: value.description,
              value: String(value.varifyMinistryId),
            };
          });
          _this.search[1].options = _this.verifyMinistries;
          _this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
